/*
 * @Auther: 罗耀祖
 * @Date: 2021-07-29 12:01:29
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2021-07-29 12:10:37
 * @name: api接口编辑类
 * @Description: api接口编辑类
 * @FilePath: \backstage\src\api\apiEdit.js
 * @Author: DESKTOP-1QU67QM
 */
import apiBase from "./apiBase.js";
const apiEdit = class apiEdit extends apiBase {
  constructor() {
    super();
  }
  /**
   * @Auther: 罗耀祖
   * @LastEditors: 罗耀祖
   * @description: get方式
   * @param {String} url 接口短地址
   * @param {Object} data 请求参数
   * @param {Object} instance 请求实例
   * @param {Function} callback 回调函数
   */
  get(url, data, instance) {
    super.base(instance);
    super.alertMessage(instance);
    return instance.get(url, { params: data });
  }
  /**
   * @Auther: 罗耀祖
   * @LastEditors: 罗耀祖
   * @description: post方式
   * @param {String} url 接口短地址
   * @param {Object} data 请求参数
   * @param {Object} instance 请求实例
   * @param {Function} callback 回调函数
   */
  post(url, data, instance) {
    instance.interceptors.request.use(config => {
      config.headers.Accept = 'application/json';
      return config;
    });
    super.base(instance);
    super.alertMessage(instance);
    return instance.post(url, data);
  }
}

export default apiEdit;
